import React, { useContext, useReducer, useEffect } from "react";
import { Row, Col, FormControl, Form } from "react-bootstrap";
import Pagination from "../Components/Pagination";
import Loading from "./Loading";
import Statics from "../Statics";
import ComponentContext from "../Context";

const initialState = {
  searchText: "",
  loadingState: Statics.NOT_LOADED,
  current_page: 1,
  pageSize: 12,
  province: [],
  provinceId: "0",
  provinceLoadingState: Statics.NOT_LOADED,
  teachers: [],
};

function reducer(state, action) {
  const { type, payload } = action;
  return { ...state, [type]: payload };
}

const Teachers = () => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const {
    current_page,
    pageSize,
    teachers,
    province,
    loadingState,
    provinceLoadingState,
    searchText,
    provinceId,
  } = state;

  const setPage = data => dispatch({ type: "current_page", payload: data });
  const setTeachers = data => dispatch({ type: "teachers", payload: data });
  const setProvince = data => dispatch({ type: "province", payload: data });
  const setLoadingState = data =>
    dispatch({ type: "loadingState", payload: data });
  const setProvinceLoadingState = data =>
    dispatch({ type: "provinceLoadingState", payload: data });
  const setSearchText = data => dispatch({ type: "searchText", payload: data });
  const setProvinceId = data => dispatch({ type: "provinceId", payload: data });

  const context = useContext(ComponentContext);

  const getProvince = () => {
    setProvinceLoadingState(Statics.LOADING);
    const storedProvince = sessionStorage.getItem("allProvince");
    if (storedProvince) {
      setProvince(JSON.parse(storedProvince));
      setProvinceLoadingState(Statics.LOADED);
    } else {
      context.ApiDriver.getProvince(
        {},
        data => {
          setProvince(data.data);
          sessionStorage.setItem("allProvince", JSON.stringify(data.data));
          setProvinceLoadingState(Statics.LOADED);
        },
        error => {
          console.log(error);
          setProvinceLoadingState(Statics.CAUSED_ERROR);
        },
      );
    }
  };

  const getTeachers = () => {
    setLoadingState(Statics.LOADING);
    const storedTeachers = sessionStorage.getItem("allTeachers");
    if (storedTeachers) {
      setTeachers(JSON.parse(storedTeachers));
      setLoadingState(Statics.LOADED);
    } else {
      context.ApiDriver.getTeachers(
        { page_size: 1000 },
        data => {
          setTeachers(data.data);
          sessionStorage.setItem("allTeachers", JSON.stringify(data.data));
          setLoadingState(Statics.LOADED);
        },
        error => {
          console.log(error);
          setLoadingState(Statics.CAUSED_ERROR);
        },
      );
    }
  };

  useEffect(() => {
    if (loadingState === Statics.NOT_LOADED) {
      getTeachers();
    }
    if (provinceLoadingState === Statics.NOT_LOADED) {
      getProvince();
    }
    // eslint-disable-next-line
  }, [loadingState, provinceLoadingState]);

  const filteredTeachers = teachers.filter(teacher => {
    const fullName = (
      teacher.first_name +
      " " +
      teacher.last_name
    ).toLowerCase();
    const query = searchText.toLowerCase();
    const matchesName = query === "" || fullName.includes(query);
    const matchesProvince =
      provinceId === "0" ||
      (teacher.city &&
        teacher.city.province &&
        String(teacher.city.province.id) === provinceId);
    return matchesName && matchesProvince;
  });

  const totalCountComputed = filteredTeachers.length;
  const startIndex = (current_page - 1) * pageSize;
  const currentPageTeachers = filteredTeachers.slice(
    startIndex,
    startIndex + pageSize,
  );

  return (
    <Row className="justify-content-center">
      <Col className="mx-0">
        {loadingState === Statics.LOADED && (
          <Row className="px-2 py-3 mataData-controls  ts-controls py-md-2 w-100 mx-0">
            <Col
              md={8}
              sm={12}
              className="d-flex justify-content-center align-items-center ">
              <FormControl
                onChange={e => {
                  setSearchText(e.target.value);
                  setPage(1);
                }}
                placeholder="نام یا نام خانوادگی"
                value={searchText}
              />
            </Col>
            <Col
              md={4}
              sm={12}
              className="d-flex justify-content-center align-items-center">
              <Form.Group
                controlId="provinceSelect"
                className="w-100 mt-2 mb-md-2">
                <Form.Control
                  as="select"
                  onChange={e => {
                    setProvinceId(e.target.value);
                    setPage(1);
                  }}
                  value={provinceId}>
                  <option value="0">همه‌ی استان‌ها</option>
                  {provinceLoadingState === Statics.LOADED &&
                    province.map(pr => (
                      <option key={pr.id} value={pr.id}>
                        {pr.title}
                      </option>
                    ))}
                </Form.Control>
              </Form.Group>
            </Col>
          </Row>
        )}
        <div className="justify-content-center mx-0">
          {(loadingState === Statics.LOADING ||
            loadingState === Statics.NOT_LOADED) && (
            <div className="pajoohyar-loading">
              <Loading />
            </div>
          )}
          {loadingState === Statics.LOADED && (
            <>
              <div className="ts-list">
                {loadingState === Statics.LOADED &&
                currentPageTeachers.length > 0
                  ? currentPageTeachers.map(ts => (
                      <div key={ts.id} className="ts-card">
                        <div className="ts-profile-pic">
                          <img src={ts.image} alt="عکس استاد" />
                        </div>

                        <h2>{ts.first_name + " " + ts.last_name}</h2>

                        <p>
                          {ts.grade + " " + ts.field + " " + ts.university}
                          <br />
                          {ts.email}
                          <br />
                          {ts.city.title + " - " + ts.city.province.title}
                          <br />
                        </p>
                        <div className="ts-buttons">
                          <a
                            href={ts.resume}
                            className="resume"
                            target="_blunk">
                            مشاهده رزومه
                          </a>
                        </div>
                      </div>
                    ))
                  : ""}
                {loadingState === Statics.LOADED &&
                  filteredTeachers.length === 0 &&
                  "موردی یافت نشد"}
              </div>
              {totalCountComputed > pageSize && (
                <Row className="justify-content-center ts-pagination">
                  <Pagination
                    onPageChange={setPage}
                    currentPage={current_page}
                    totalCount={totalCountComputed}
                    pageSize={pageSize}
                  />
                </Row>
              )}
            </>
          )}
        </div>
      </Col>
    </Row>
  );
};

export default Teachers;
